export default {"src":"/_next/static/image/src/components/ComparisonChart/ollie_font.014d5e7858d80ab5da85391f260837a4.svg","height":25,"width":50};